import React from 'react';
import ReactDOM from 'react-dom/client';
import CurrencyManager from './CurrencyManager';

const root = ReactDOM.createRoot( document.getElementById( 'cmgf-react-app' ) );
root.render(
	<React.StrictMode>
		<CurrencyManager />
	</React.StrictMode>
);
